export default "__VITE_ASSET__DPsRi9qA__"